export default __webpack_public_path__ + "static/media/Group 3175@2x.a13c8df9.png";